// @material-tailwind/react components
import { Typography } from "@material-tailwind/react";

// page components
import Feature from "components/cards/feature";

export default function SectionFeatures() {
  const features = [
    {
      icon: "dashboard",
      title: "CPP",
      desc: "C++ is a high-level, general-purpose programming language that builds upon the foundation of the C programming language. It was developed as an extension to C with added features that enhance programming efficiency and enable object-oriented programming (OOP). C++ combines the low-level capabilities of C with high-level abstractions, making it suitable for a wide range of applications.",
    },
    {
      icon: "terminal",
      title: "Python",
      desc: "Python is a high-level, interpreted programming language known for its simplicity and readability. Created in the late 1980s, Python emphasizes code readability and a clean syntax, making it an excellent choice for both beginners and experienced developers. Python's versatility extends from web development and scientific computing to automation and artificial intelligence.",
    },
    {
      icon: "description",
      title: "Java",
      desc: "Java is a versatile, object-oriented programming language that emerged in the mid-1990s. Renowned for its portability and robustness, Java's write once, run anywhere capability allows developers to create applications that can run on various platforms without modification. Java's popularity lies in its strong emphasis on reliability, security, and extensive libraries.",
    },
    {
      icon: "view_carousel",
      title: "Data Structures and Algorithms",
      desc: "Data Structures and Algorithms (DSA) form the bedrock of computer science, providing systematic methods for organizing and processing data efficiently. Data structures enable the storage and retrieval of data, while algorithms offer step-by-step instructions for solving computational problems. Mastery of DSA is crucial for developing efficient and optimized software solutions.",
    },
  ];

  return (
    <section className="py-10 lg:py-20">
      <div className="mx-auto mb-24 w-full text-center md:w-3/4 lg:w-1/2">
        <Typography
          variant="h2"
          className="mb-2 font-semibold tracking-normal text-[#1A237E]"
        >
          Data Structures and Algorithms
        </Typography>
        <Typography className="mb-2 text-lg font-light text-[#1A237E]/60">
          Data structures are containers that organize and store data. They
          include arrays, linked lists, stacks, queues, trees, graphs, and hash
          tables. The choice of data structure influences the efficiency of data
          manipulation and retrieval.
        </Typography>
      </div>
      <div className="flex flex-row flex-wrap content-center">
        {features.map(({ icon, title, desc }, key) => (
          <div
            key={key}
            className="mb-12 w-full max-w-full px-3 sm:w-1/2 sm:flex-none lg:mb-0 xl:mb-0 xl:w-1/4"
          >
            <Feature icon={icon} title={title}>
              {desc}
            </Feature>
          </div>
        ))}
      </div>
    </section>
  );
}
